import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { SolicitudesApi } from "../api/SolicitudesApi";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

// Historial paginado de las veces que se repitió el análisis de una solicitud
export const useHistorialRepeticiones = () => {
    const { getRepeticionesAnalisis, cargando } = SolicitudesApi();

    const [modalAbierto, setModalAbierto] = useState(false);
    const [solicitud, setSolicitud] = useState(null);
    const [repeticiones, setRepeticiones] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    // solo se aplica la respuesta de la última consulta
    const ultimaConsulta = useRef(0);

    const GetRepeticiones = async () => {
        const consulta = ++ultimaConsulta.current;

        try {
            const response = await getRepeticionesAnalisis(solicitud.id, {
                page: paginaSeleccionada,
            });

            if (consulta !== ultimaConsulta.current) return;

            setRepeticiones(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            if (consulta !== ultimaConsulta.current) return;

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el historial de repeticiones.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (modalAbierto && solicitud) {
            GetRepeticiones();
        }
    }, [modalAbierto, solicitud, paginaSeleccionada]);

    // se limpia lo de la solicitud anterior para no mostrarlo mientras carga
    const AbrirHistorial = (item) => {
        setRepeticiones([]);
        setCantidadResultados(0);
        setPaginaSeleccionada(1);
        setSolicitud(item);
        setModalAbierto(true);
    };

    const CerrarModal = () => setModalAbierto(false);

    return {
        modalAbierto,
        solicitud,
        repeticiones,
        paginaSeleccionada,
        setPaginaSeleccionada,
        cantidadResultados,
        AbrirHistorial,
        CerrarModal,
        cargando,
    };
};
